import { render, staticRenderFns } from "./ModalBoletim.vue?vue&type=template&id=667d4ef2&"
import script from "./ModalBoletim.vue?vue&type=script&lang=js&"
export * from "./ModalBoletim.vue?vue&type=script&lang=js&"
import style0 from "./ModalBoletim.vue?vue&type=style&index=0&id=667d4ef2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports